import React from "react";
import { Row, Col } from "react-bootstrap";
import { withTheme } from "styled-components";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import FormattedMessage from "@irati/utils/lang";
import { Body, Label } from "@irati/ui/src/Typography";
import { UnavailableCard, StyledCol } from "./styled/UnavailableDeal";
var UnavailableDeal = function (_a) {
    var theme = _a.theme;
    return (React.createElement(UnavailableCard, { noBorder: true, tiny: true },
        React.createElement(Row, null,
            React.createElement(StyledCol, { xsHidden: true, sm: 2 },
                React.createElement(Icon, { icon: IconTypes.circleDisable, size: 25, color: theme.colors.utility.ink })),
            React.createElement(Col, { xs: 12, sm: 10 },
                React.createElement(Label, { large: true, weight: "bold" },
                    React.createElement(FormattedMessage, { id: "perks.components.dealInfoBlock.unavailableDeal.header" })),
                React.createElement(Body, { small: true, margin: [1, 0, 0] },
                    React.createElement(FormattedMessage, { id: "perks.components.dealInfoBlock.unavailableDeal.text" }))))));
};
export default withTheme(UnavailableDeal);
